/* eslint-disable max-len */
import PropTypes from 'prop-types';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { checkRol } from '../../../security';
import { inspector, proveedorNotificador } from '../../../security/constantsRols';
import { Line } from '../../../utils/globalPropTypes';
import { ubicationTypeEnum, workReportLineStatus } from '../../../utils/dataStatus';
import CommentsWorkReportButton from '../WorkReportActionButtons/CommentsWorkReportButton/CommentsWorkReportButton';
// eslint-disable-next-line max-len
import FilesWorkReportButton from '../WorkReportActionButtons/FilesWorkReportButton/FilesWorkReportButton';
import InspectWorkReportButton from '../WorkReportActionButtons/InspectWorkReport/InspectWorkReportButton';
import SendToApproveButton from '../WorkReportActionButtons/SendToApproveButton/SendToApproveButton';
import WorkReportLineMenu from '../WorkReportActionButtons/WorkReportLineMenu/WorkReportLineMenu';
import ProgramPointsButton from '../WorkReportActionButtons/ProgramPointsButton/ProgramPointsButton';

const ActionsButtons = (props) => {
  const {
    canVisualizeComments,
    canSendComments,
    canSendToApprove,
    canVisualizeFiles,
    canAttachFiles,
    expertReview,
    amount,
    changeInLines,
    fetchToApproveALine,
    line,
    newFetch,
    selectedDate,
    setChangeInLines,
    setNewFetch,
    setShowModalMenu,
    showModalMenu,
    startDate,
    workReportId,
    typeOfUbication,
    disabledEditStateCancelOrFinish,
    monthly,
    asignationType,
    setAmount,
    disabledPPModal,
    setIsRectifyAmount,
    isRectifyAmount,
    notificaPP
  } = props;

  const showInspectWorkReportButton =
    (line.disabled && line.estadoEnum !== workReportLineStatus.enviar) || checkRol(inspector);

  const showSendToApproveButton =
    (!line.disabled || line.estadoEnum === workReportLineStatus.enviar) && !checkRol(inspector);

  const showProgramPointButton =
    checkRol(proveedorNotificador) && typeOfUbication?.id === ubicationTypeEnum.pozo && notificaPP;
  const isNotifyingProviderRole = checkRol(proveedorNotificador);

  return (
    <Row className="d-flex justify-content-evenly align-items-center">
      {showInspectWorkReportButton ? (
        <Col className="p-0" sm={2}>
          <InspectWorkReportButton
            asignationType={asignationType}
            className="inspector_work_button"
            disabled={!expertReview}
            line={line}
            setNewFetch={setNewFetch}
            typeOfUbication={typeOfUbication}
          />
        </Col>
      ) : null}
      {showSendToApproveButton ? (
        <Col className="p-0" sm={2}>
          <SendToApproveButton
            amount={amount}
            changeInLines={changeInLines}
            disabled={
              line.disabled ||
              (showProgramPointButton && line.tienePuntosPrograma) ||
              !canSendToApprove ||
              amount === null ||
              ((amount === 0 || amount === '0') &&
                line.estadoEnum !== workReportLineStatus.enviar) ||
              disabledEditStateCancelOrFinish
            }
            fetchToApproveALine={fetchToApproveALine}
            line={{ ...line, blockedBySap: line?.bloqueadoEnSap && isNotifyingProviderRole }}
            monthly={monthly}
            newFetch={newFetch}
            selectedDate={selectedDate}
            setChangeInLines={setChangeInLines}
            setNewFetch={setNewFetch}
            workReportId={workReportId}
          />
        </Col>
      ) : null}
      {showProgramPointButton && (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={<Tooltip id="program-point">Punto de programa</Tooltip>}
          placement="top"
        >
          <Col className="p-1" sm={2}>
            <ProgramPointsButton
              amount={amount}
              disabledPPModal={disabledPPModal}
              isRectifyAmount={isRectifyAmount}
              line={{ ...line, tipoAsignacion: asignationType }}
              selectedDate={selectedDate}
              setAmount={setAmount}
              setIsRectifyAmount={setIsRectifyAmount}
              setNewFetch={setNewFetch}
              typeOfUbication={typeOfUbication}
            />
          </Col>
        </OverlayTrigger>
      )}
      <Col className="p-1" sm={2}>
        <FilesWorkReportButton
          canAttachFiles={canAttachFiles}
          canVisualizeFiles={canVisualizeFiles}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          line={line}
          setNewFetch={setNewFetch}
          startDate={startDate}
        />
      </Col>
      <Col className="p-1" sm={2}>
        <CommentsWorkReportButton
          canSendComments={canSendComments}
          canVisualizeComments={canVisualizeComments}
          line={line}
          monthly={monthly}
          startDate={startDate}
        />
      </Col>
      <Col className="p-0" sm={2}>
        <WorkReportLineMenu setShowModalMenu={setShowModalMenu} showModalMenu={showModalMenu} />
      </Col>
    </Row>
  );
};

ActionsButtons.propTypes = {
  canVisualizeComments: PropTypes.bool,
  canSendComments: PropTypes.bool,
  canVisualizeFiles: PropTypes.bool,
  canAttachFiles: PropTypes.bool,
  canSendToApprove: PropTypes.bool,
  expertReview: PropTypes.bool.isRequired,
  workReportId: PropTypes.number.isRequired,
  showModalMenu: PropTypes.bool.isRequired,
  setShowModalMenu: PropTypes.func.isRequired,
  line: Line.isRequired,
  amount: PropTypes.number,
  selectedDate: PropTypes.string.isRequired,
  changeInLines: PropTypes.bool.isRequired,
  setChangeInLines: PropTypes.func,
  newFetch: PropTypes.bool.isRequired,
  setNewFetch: PropTypes.func.isRequired,
  fetchToApproveALine: PropTypes.func,
  startDate: PropTypes.string.isRequired,
  typeOfUbication: PropTypes.string.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  monthly: PropTypes.bool,
  asignationType: PropTypes.number,
  setAmount: PropTypes.func,
  disabledPPModal: PropTypes.bool,
  setIsRectifyAmount: PropTypes.func,
  isRectifyAmount: PropTypes.bool,
  notificaPP: PropTypes.bool.isRequired
};

ActionsButtons.defaultProps = {
  canVisualizeComments: true,
  canSendToApprove: true,
  canVisualizeFiles: true,
  canAttachFiles: true,
  canSendComments: true,
  setChangeInLines: () => {
    /* empty */
  },
  fetchToApproveALine: () => {
    /* empty */
  },
  amount: null,
  monthly: false,
  asignationType: null,
  setAmount: () => {
    /* empty */
  },
  disabledPPModal: false,
  setIsRectifyAmount: () => {
    /* empty */
  },
  isRectifyAmount: false
};

export default ActionsButtons;
